import React from 'react';
import Header from '~/components/header/Header';  
import Block from '~/components/ui/block/Block';
import Button from '~/components/ui/button/Button';
import { styled } from "styled-components";

const HowDoesThisWork = styled.div`

  padding: 20px;

  .howDoesThisWork_body {
    display: flex;
    flex-direction: row;
  }
  
  .howDoesThisWork_body section {
    padding-left: 5px;
    padding-right: 5px;
  }
  
  .howDoesThisWork_disclaimer {
    padding: 22px 35px;
  
    border-radius: 9.088px;
    background: var(--Light-F5, #F5F5F5);
  }
  
  .howDoesThisWork_disclaimer strong {
    color: var(--Dark-2E, #2E2E2E);
    font-variant-numeric: lining-nums proportional-nums;
    
    font-size: 12.723px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    letter-spacing: 1.272px;
    text-transform: uppercase;
  }
  
  .beforeStart p {
    padding-top: 20px;
  }
  
  .howDoesThisWork_disclaimer p {
    color: var(--Black, #000);
    font-variant-numeric: lining-nums proportional-nums;
    
    font-size: 10.905px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
  }
  
  .howDoesThisWork_btnGroup {
    margin-top: 20px;
    text-align: right;
  }
`;

const HowItWork = ({activeStep, btnTitle, btnEvent}) => {
  return (
    <div className='wizardWrapper'>
      <div className='header'>
        <Header activeStep={activeStep} />
      </div>
      <div className='wz_container'>
        <Block>
          <HowDoesThisWork>
            <h1>Instructions for Customizing Your Workplace Violence Prevention Course</h1>
            <div className='howDoesThisWork_body'>
              <section className='beforeStart'>
                <iframe width="560" height="315"
                        src="https://www.youtube.com/embed/AR8UG2CnmHk?si=QvLHkcNQH2iYr7Xr&amp;controls=0"
                        title="YouTube video player" frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
                <p>Before you get started, make sure you have your finalized Workplace Violence Prevention Plan readily accessible. This plan is crucial as it will provide the foundational content and context necessary to effectively adapt your custom training materials to meet compliance standards.</p>
              </section>
              <section style={{paddingLeft: '20px'}}>
                <p>As you proceed through the customization process, carefully follow the instructions provided for each step and fill in all necessary content. This information will be used to create the customized portion of your Workplace Violence Prevention course, which you will be able to view at each step. If you need to exit mid-process, your draft will be saved and you can return to finish from where you left off.</p>
                <p>Once you have entered all of the required content, you can preview your customized slides within their respective chapters. Please note that you will also be able to preview the course in its entirety once you have published your customized slides. Your course will be available in the library. From there you can revise your slides, as well as make copies for additional locations.</p>
                <div className='howDoesThisWork_disclaimer'>
                  <strong>DISCLAIMER</strong>
                  <p>Customer is solely responsible for all Customer Content provided herein and EasyLlama shall not be liable for any Customer Content published. In no event shall EasyLlama, its employees, or its contributors be liable for any direct, indirect, incidental, special, exemplary, or consequential damages (including, but not limited to, procurement or substitute goods or services; loss of use, data, or profits; or business interruption) however caused and on any theory of liability, arising in any way out of the use of this course.</p>
                </div>
              </section>
            </div>
            <div className='howDoesThisWork_btnGroup'>
              <Button className='primaryBtn' title={'Get Started'} onClick={btnEvent} />
            </div>
          </HowDoesThisWork>
        </Block>
      </div>
    </div>
  );
}

export default HowItWork;
